import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { CreateCorporateLocationDto, CorporateLocationDto } from '../../models';
import { HttpHelper } from '@umss/shared/utils';

@Injectable({
  providedIn: 'root'
})
export class CorporateLocationsBulkService {
  private readonly baseUrl = '/api/corporate-locations/bulk';
  private readonly http = inject(HttpClient);

  create(
    corporationId: string,
    requestBody: CreateCorporateLocationDto[]
  ): Observable<CorporateLocationDto[]> {
    const params = HttpHelper.toHttpParams({ corporationId });
    return this.http.post<CorporateLocationDto[]>(
      `${this.baseUrl}`,
      requestBody,
      { params }
    );
  }

  delete(requestBody: string[]): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}`, { body: requestBody });
  }
}
